export default __webpack_public_path__ + "0e8af05917ffd98754cd39ef4a4448fd.svg";